'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of build plan web
 */ const BuildPlanWeb = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 107 107",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "53.5",
                cy: "53.5",
                r: "53.5",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "20.5312",
                y: "32.5332",
                width: "65.7905",
                height: "38.3176",
                rx: "3.61486",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                opacity: "0.7",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.5312 63.9116V67.2368C20.5312 69.2333 22.1497 70.8517 24.1461 70.8517H82.7069C84.7034 70.8517 86.3218 69.2333 86.3218 67.2368V63.9116H20.5312Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "43.3789",
                y: "70.8516",
                width: "20.2432",
                height: "6.21757",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "36.293",
                y: "76.9238",
                width: "34.2689",
                height: "1.73514",
                rx: "0.867568",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "30",
                y: "58",
                width: "47",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "30",
                y: "53",
                width: "47",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "30",
                y: "48",
                width: "47",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "67",
                y: "36",
                width: "10.3846",
                height: "9",
                rx: "0.504048",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M72.7274 39.9729H74.6157V41.0424H72.7274V42.9223H71.6579V41.0424H69.7695V39.9729H71.6579V38.0762H72.7274V39.9729Z",
                fill: theme.ds5.asset[assetColor]["100"]
            })
        ]
    });
};

exports.BuildPlanWeb = BuildPlanWeb;
//# sourceMappingURL=BuildPlanWeb.cjs.map
